import { gql } from '@apollo/client';
import PRODUCT_FRAGMENT from './product';
import PRODUCT_CURRICULUM_FRAGMENT from './product-curriculum';

const CLASSROOM_LICENSE_USAGE_FRAGMENT = gql`
  fragment BaseClassroomLicenseUsage on ClassroomLicenseUsage {
    productId
    assignedCount
    product {
      ...BaseProduct
    }
    productCurriculum {
      ...BaseProductCurriculum
    }
  }
  ${PRODUCT_FRAGMENT}
  ${PRODUCT_CURRICULUM_FRAGMENT}
`;

export default CLASSROOM_LICENSE_USAGE_FRAGMENT;
